"use client";
import React from "react";
import TextInput from "./form-components/TextInput";
import SelectInput from "./form-components/SelectInput";
import MultiSelect from "./form-components/MultiSelect";
import Switch from "./form-components/Switch";
import Checkbox from "./form-components/Checkbox";
import { PersonalProfileFormData } from "./context/_validation";
import { useFormContext } from "./context/FormContext";
import ButtonSimple, { ButtonOutline } from "@/components/ui/button-simple";

const interests = [
  { label: "Technology", value: "tech" },
  { label: "Gaming", value: "gaming" },
  { label: "Photography", value: "photo" },
  { label: "Audio", value: "audio" },
  { label: "Smart Home", value: "smarthome" },
  { label: "Wearables", value: "wearables" },
];

const productCategories = [
  { label: "Laptops", value: "laptops" },
  { label: "Tablets", value: "tablets" },
  { label: "Smartphones", value: "phones" },
  { label: "Gaming Consoles", value: "gaming" },
  { label: "Cameras", value: "cameras" },
  { label: "Audio Devices", value: "audio" },
  { label: "Smart Home Devices", value: "smarthome" },
  { label: "Wearables", value: "wearables" },
];

const purchaseTimelines = [
  { label: "Within 1 week", value: "1w" },
  { label: "Within 1 month", value: "1m" },
  { label: "Within 3 months", value: "3m" },
  { label: "Within 6 months", value: "6m" },
  { label: "More than 6 months", value: "6m+" },
];

const BuyingProfilePersonal = () => {
  const { personalMethods, handleBack, handleFormSubmit } = useFormContext();
  const { register, formState, watch, setValue } = personalMethods;

  return (
    <form
      onSubmit={personalMethods.handleSubmit(data => handleFormSubmit(data, "personal"))}
      className="mt-8 space-y-4"
    >
      <TextInput
        label="Personal email"
        type="email"
        {...register("personalEmail")}
        error={formState.errors.personalEmail?.message}
        placeholder="Enter your email"
      />

      <SelectInput
        label="Personal interests"
        value={watch("interests")}
        onChange={value => setValue("interests", value, { shouldValidate: true })}
        error={formState.errors.interests?.message}
        options={interests}
        // placeholder="Select your interests"
      />

      <MultiSelect
        label="Preferred product categories"
        value={watch("productCategories") || []}
        onValueChange={value => setValue("productCategories", value, { shouldValidate: true })}
        error={formState.errors.productCategories?.message}
        options={productCategories}
        placeholder="Select product categories"
      />

      <div className="pb-4 pt-4">
        <p className="mb-4 text-[15px] font-medium text-system-disabled">
          Help us tailor your experience. Share your notification preferences and future purchasing
          plans
        </p>

        <div>
          <p className="mb-[11px] text-sm text-system-titanium">Preferred notification method</p>
          <div className="flex gap-12">
            <Switch
              id="email-notifications"
              label="E-mail"
              checked={watch("notificationPreferences.email")}
              onCheckedChange={checked => setValue("notificationPreferences.email", checked)}
            />
            <Switch
              id="sms-notifications"
              label="SMS"
              checked={watch("notificationPreferences.sms")}
              onCheckedChange={checked => setValue("notificationPreferences.sms", checked)}
            />
          </div>
        </div>
      </div>

      <SelectInput
        label="When do you plan to purchase next?"
        value={watch("purchaseTimeline")}
        onChange={value => setValue("purchaseTimeline", value, { shouldValidate: true })}
        error={formState.errors.purchaseTimeline?.message}
        options={purchaseTimelines}
        placeholder="Select timeline"
      />

      <div className="pt-4">
        <Checkbox
          id="privacy-policy"
          checked={watch("privacyPolicy")}
          onCheckedChange={checked => setValue("privacyPolicy", checked, { shouldValidate: true })}
          error={formState.errors.privacyPolicy?.message}
          label="I confirm that I have read and agree to the Privacy Policy"
        />
      </div>

      <div className="flex gap-2.5 pt-2">
        <span className="w-full max-w-[110px]">
          <ButtonOutline type="button" onClick={handleBack} className="h-[42px]">
            Go back
          </ButtonOutline>
        </span>
        <span className="w-full max-w-[200px]">
          <ButtonSimple
            type="submit"
            className="text:sm h-[42px] rounded-lg text-white transition-colors"
          >
            Join the waitlist
          </ButtonSimple>
        </span>
      </div>
    </form>
  );
};

export default BuyingProfilePersonal;
